import * as React from "react";
const SvgTriangleUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 500 537", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0.866 460L265.87 1 530.874 460z" }));
export default SvgTriangleUp;
